export default "__VITE_ASSET__CVJd_6kR__"